import { getStore } from '~/mobx/AppStore';
import getSelectedRegionUpdateAttributes from './getSelectedRegionUpdateAttributes';

const handleChangeRegionAttribute = (key: string, value: string) => {
    const { generalSettingsStore } = getStore();
    const { regionSettingsData, setRegionSettingsData } = generalSettingsStore;
    const attributesToUpdate = getSelectedRegionUpdateAttributes([...regionSettingsData], key, value);
    setRegionSettingsData(attributesToUpdate);
};

export default handleChangeRegionAttribute;
